import { useEffect, useRef, useState } from "react";
import { tipFor } from "@/lib/tips";

const KEY = "clc-hover-help";
export const hoverHelpOn = () => localStorage.getItem(KEY) !== "off";
export const setHoverHelp = (on) => { localStorage.setItem(KEY, on ? "on" : "off"); window.dispatchEvent(new Event(KEY)); };

function resolve(start) {
  for (let el = start; el && el !== document.body; el = el.parentElement) {
    if (el.title) { el.dataset.tip = el.title; el.removeAttribute("title"); }
    const id = el.dataset?.testid;
    const text = (id && tipFor(id)) || el.dataset?.tip;
    if (text) return { el, text };
  }
  return null;
}

export const HoverHelp = () => {
  const [tip, setTip] = useState(null);
  const [on, setOn] = useState(hoverHelpOn);
  const timer = useRef(null), cur = useRef(null);

  useEffect(() => {
    const sync = () => setOn(hoverHelpOn());
    window.addEventListener(KEY, sync);
    return () => window.removeEventListener(KEY, sync);
  }, []);

  useEffect(() => {
    if (!on) { setTip(null); return; }
    const hide = () => { clearTimeout(timer.current); cur.current = null; setTip(null); };
    const over = (e) => {
      if (e.pointerType === "touch") return;
      const hit = resolve(e.target);
      if (hit?.el === cur.current) return;
      hide();
      if (!hit) return;
      cur.current = hit.el;
      timer.current = setTimeout(() => {
        const r = hit.el.getBoundingClientRect();
        const below = r.bottom + 44 < window.innerHeight;
        setTip({ text: hit.text, x: Math.max(8, Math.min(window.innerWidth - 268, r.left + r.width / 2 - 130)), y: below ? r.bottom + 8 : r.top - 8, below });
      }, 450);
    };
    document.addEventListener("pointerover", over);
    document.addEventListener("pointerdown", hide, true);
    window.addEventListener("scroll", hide, true);
    window.addEventListener("blur", hide);
    return () => {
      hide();
      document.removeEventListener("pointerover", over);
      document.removeEventListener("pointerdown", hide, true);
      window.removeEventListener("scroll", hide, true);
      window.removeEventListener("blur", hide);
    };
  }, [on]);

  if (!tip) return null;
  return (
    <div role="tooltip" data-testid="hover-help-tip"
      className="fixed z-[9999] w-[260px] flex justify-center pointer-events-none animate-in fade-in-0 zoom-in-95 duration-150"
      style={{ left: tip.x, top: tip.y, transform: tip.below ? "none" : "translateY(-100%)" }}>
      <span className="px-2.5 py-1.5 rounded-md bg-[#0B0C10]/95 border border-[#FFB800]/40 text-[11px] leading-snug text-slate-100 shadow-[0_6px_24px_rgba(0,0,0,0.6),0_0_12px_rgba(255,184,0,0.15)] backdrop-blur-md text-center">
        {tip.text}
      </span>
    </div>
  );
};
